/**
 * Form thêm thông số
 */
import { Button, Form, Input, Select, notification } from "antd";
import { useForm } from "antd/lib/form/Form";
import { setModal } from "features/modalSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  PayloadType,
  // ParameterType,
  SelectOptionType,
  // UserType,
} from "type";
import { closeModal, getYupSync } from "utils";
import { useEffect, useState } from "react";
import * as yup from "yup";
// import { getRoles } from "features/roleSlice";
import { getTypeGroups } from "features/typeGroupSlice";
import _ from "lodash";
import { getSharedDatas } from "features/sharedDataSlice";
import queryString from "query-string";
import {
  getParameters,
  updateParameters,
  // createParameters,
} from "features/parameterSlice";

function CUParameter({ idUpdate = undefined, record = undefined }: any) {
  const [form] = useForm();
  const dispatch = useDispatch();
  const { query } = useSelector((state: any) => state.userReducer);
  const { open } = useSelector((state: any) => state.modalReducer);
  const [listDV, setListDV] = useState<SelectOptionType[]>([]);

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
    form.setFieldValue("unitId", _.get(record, "unitId", null));
    form.setFieldValue("value", _.get(record, "param.value", null));
    form.setFieldValue("name", _.get(record, "name", null));
    form.setFieldValue("code", _.get(record, "code", null));
    form.setFieldValue("maxValue", _.get(record, "param.maxValue"));
    form.setFieldValue("minValue", _.get(record, "param.minValue", null));
  }, [record, open]);

  //Lấy danh sách tài khoản
  function handleGetParameter() {
    const payload: PayloadType = {
      query: queryString.stringify(
        {
          ...query,
          populate: "actionIds",
        },
        {
          skipNull: true,
          skipEmptyString: true,
        }
      ),
      skipUpdateReducer: false,
      callback: {
        success() {},
        failed(errorMessage) {
          notification.error({
            message: "Có lỗi xảy ra trong quá trình lấy danh sách!",
            description: errorMessage,
          });
        },
      },
    };
    dispatch(getParameters(payload));
  }
  const formSchema = yup.object().shape({
    name: yup.string().required("Vui lòng nhập tên thông số!"),
    minValue: yup
      .number()
      .typeError("Vui lòng nhập giá trị min !")
      .notRequired()
      .min(0, "Giá trị phải là số dương và lớn hơn 0"),
    maxValue: yup
      .number()
      .typeError("Vui lòng nhập giá trị max !")
      .notRequired()
      .min(0, "Giá trị phải là số dương và lớn hơn 0"),
    unitId: yup.string().required("Vui lòng chọn đơn vị!"),
  });
  const yupSync = [getYupSync(formSchema)];
  function handleSubmit() {
    const values = form.getFieldsValue([
      "name",
      "minValue",
      "maxValue",
      "unitId",
    ]);
    handleUpdateParameter(values);
  }
  function handleUpdateParameter(values: any) {
    const payload: PayloadType = {
      params: _.get(record, "actionId"),
      body: {
        name: values?.name,
        code: record?.code,
        minValue: values?.minValue,
        maxValue: values?.maxValue,
        unitId: values?.unitId,
      },
      callback: {
        success() {
          notification.success({
            message: "Cập nhật thông số thành công!",
          });
          handleGetParameter();
          closeModal(dispatch, setModal);
        },
        failed(errorMessage) {
          notification.error({
            message: "Không thể cập nhật thông số!",
            description: errorMessage,
          });
        },
      },
    };
    dispatch(updateParameters(payload));
  }

  // Lấy options cho ô đơn vị
  const getFieldDV = () => {
    const payload: PayloadType = {
      query: queryString.stringify({
        page: 1,
        limit: 999,
        code: `UNIT`,
      }),
      skipUpdateReducer: true,
      callback: {
        success(roleId) {
          const results = _.get(roleId, "results", []);
          const typeGroupId = _.get(results, "[0].id", null);
          const payload1: PayloadType = {
            query: queryString.stringify({
              page: 1,
              limit: 999,
              typeGroupId: typeGroupId,
            }),
            callback: {
              success(results) {
                const listDV = results.results;
                if (!!listDV && Array.isArray(listDV)) {
                  setListDV(
                    listDV.map((item: any) => {
                      return {
                        label: item.name,
                        value: item.name,
                      };
                    })
                  );
                }
              },
              failed() {},
            },
          };
          dispatch(getSharedDatas(payload1));
        },
        failed() {},
      },
    };
    dispatch(getTypeGroups(payload));
  };

  useEffect(() => {
    getFieldDV();
  }, []);

  return (
    <Form
      form={form}
      labelCol={{ span: 8 }}
      onFinish={() => {
        handleSubmit();
      }}
      autoComplete="off"
    >
      <div className="ant-modal-body">
        <Form.Item
          required
          label={"Tên thông số"}
          name={"name"}
          rules={yupSync}
        >
          <Input placeholder="Nhập vào tên thông số" disabled={true} />
        </Form.Item>

        <Form.Item label="Min-Max" style={{ marginBottom: 0 }}>
          <Form.Item
            name={"minValue"}
            rules={yupSync}
            style={{ display: "inline-block", width: "calc(50% - 8px)" }}
          >
            <Input placeholder="Nhập giá trị min" type="number" />
          </Form.Item>
          <Form.Item
            name={"maxValue"}
            rules={yupSync}
            style={{
              display: "inline-block",
              width: "calc(50% - 8px)",
              margin: "0 8px",
            }}
          >
            <Input placeholder="Nhập giá trị max" type="number" />
          </Form.Item>
        </Form.Item>

        <Form.Item label={"Đơn vị"} name={"unitId"} rules={yupSync} required>
          <Select
            allowClear
            disabled
            placeholder="Chọn đơn vị"
            style={{ width: "100%" }}
            options={listDV.map((item: SelectOptionType) => {
              return {
                label: item.label,
                value: item.value,
              };
            })}
          />
        </Form.Item>
      </div>
      <div className="ant-modal-footer">
        <Button
          type="default"
          onClick={() => {
            closeModal(dispatch, setModal);
          }}
        >
          Huỷ
        </Button>
        <Button
          onClick={() => {
            form.submit();
          }}
          type="primary"
        >
          {"Lưu lại"}
        </Button>
      </div>
    </Form>
  );
}

export default CUParameter;
